import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Badge, Avatar as Muiavatar, IconButton } from "@mui/material";
import { EditOutlined, DeleteOutlined, MoreVert } from "@mui/icons-material";

import EditTextFields from "../editComment/editComment";
import CustomDateFormatter from "../../../../../../utils/dateTimeFormatter";
import Avatar from "../../../../../../components/Avatar";
import WorklogText from "../../../worklog/worklogTextEditor";
import CommentIcon from "../../../../../../styles/svg/coment-icon.svg";
import FormDialog from "../../../../../../components/Dialog/FormDialog";
import { CustomButton } from "../../../../../../components/Button/Button";
import CustomMenu from "../../../../../../components/Menu";
import CustomMenuItem from "../../../../../../components/Menu/CustomMenuItem";
import { useCommentItemState } from "./hooks/useCommentItemState";

const SmallAvatar = styled(Muiavatar)(({ theme }) => ({
  width: 16,
  height: 16,
  border: `2px solid ${theme.palette.background.paper}`,
}));

function ListComment({ data, cardId, showIcon = false }) {
  const {
    anchorEl,
    avatarStyle,
    canEdit,
    handleDelete,
    handleDeleteClose,
    handleDeleteConfirm,
    handleEdit,
    headShotName,
    isBetween300And699,
    isMobile,
    loading,
    setAnchorEl,
    setShowEdit,
    showDelete,
    showEdit,
  } = useCommentItemState({ cardId, data });

  return (
    <>
      {showDelete && (
        <FormDialog
          open={showDelete}
          handleClose={handleDeleteClose}
          handleSubmit={handleDeleteConfirm}
          loading={loading}
          buttonTxt={"Delete"}
          title={"Confirmation: Delete Confirmation"}
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to you want to delete this item? This action can not be
            undone
          </Typography>
        </FormDialog>
      )}
      <Box
        sx={{
          flexGrow: 1,
          px: isMobile && "",
          pl: isMobile ? 1 : "",
          width: isMobile ? "96%" : "100%",
        }}>
        <Grid container spacing={2} className="comment-container">
          <div className={isMobile ? "mobile-comment-box" : "comment-box"}>
            <Grid>
              {showIcon ? (
                <Badge
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  badgeContent={
                    <SmallAvatar alt="Remy Sharp" src={CommentIcon} />
                  }>
                  <Avatar
                    title={data?.username}
                    className={
                      " header-avatar add-comment-avtar comment-box-img"
                    }
                    user_image={data?.user_image}
                    style={avatarStyle}>
                    {headShotName}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  title={data?.username}
                  className={" header-avatar add-comment-avtar comment-box-img"}
                  user_image={data?.user_image}
                  style={avatarStyle}>
                  {headShotName}
                </Avatar>
              )}
            </Grid>
            <div
              className={
                isMobile ? "mobile-comment-box-body" : "comment-box-body"
              }>
              <div className="d-flex justify-content-space-between align-items-center">
                <Grid>
                  <Typography
                    className={`comment-box-name ${
                      isMobile ? "comment-box-name-text" : ""
                    }`}>
                    {data?.username}
                  </Typography>
                </Grid>
                {!isBetween300And699 && (
                  <Grid>
                    <Typography className="comment-box-date">
                      {<CustomDateFormatter date={data?.comment_time} />}
                    </Typography>
                  </Grid>
                )}
                {isMobile && (<div>
                      <IconButton
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        className="worklog-menu-button"
                      >
                        <MoreVert />
                      </IconButton>
                      <CustomMenu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        handleClose={() => setAnchorEl(null)}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                        className="worklog-menu-items"
                      >
                        <CustomMenuItem
                          onClick={handleEdit}
                          className="worklog-menu-items-item"
                        >
                          <EditOutlined className="icon" />
                          Edit
                        </CustomMenuItem>
                        <CustomMenuItem
                          onClick={handleDelete}
                          className="worklog-menu-items-item"
                        >
                          <DeleteOutlined className="icon" />
                          Delete
                        </CustomMenuItem>
                      </CustomMenu>
                    </div>)}
              </div>
              <Grid>
                {showEdit ? (
                  <EditTextFields
                    cardId={cardId}
                    setShowEdit={setShowEdit}
                    comment_id={data?.comment_id}
                    messg={data?.comment}
                  />
                ) : (
                  <WorklogText text={data?.comment} />
                )}
              </Grid>
              {!isMobile && canEdit && !showEdit && (
                <div className="d-flex">
                  <CustomButton
                    className="comment-box-btn1 reset-btn"
                    onClick={handleEdit}>
                    Edit
                  </CustomButton>
                  <CustomButton
                    onClick={handleDelete}
                    className="comment-box-btn2 reset-btn">
                    Delete
                  </CustomButton>
                </div>
              )}

              {isBetween300And699 && (
                <Grid>
                  <Typography
                    className={
                      isMobile ? "mobile-comment-box-date" : "comment-box-date"
                    }>
                    {<CustomDateFormatter date={data?.comment_time} />}
                  </Typography>
                </Grid>
              )}
            </div>
          </div>
        </Grid>
      </Box>
    </>
  );
}

export default React.memo(ListComment);
